// Lot 723 — cultes réguliers : prochaine occurrence (heure locale du visiteur) en sautant les occurrences annulées
// par le responsable (`service_cancellations` : {kind, day, time, date "YYYY-MM-DD", new_date, new_time}).
// Lot 724 — une occurrence DÉPLACÉE (kind "moved") disparaît de sa date d'origine et réapparaît à new_date / new_time.
const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/;

export const localDateIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const fmtDM = (iso) => (iso ? iso.split("-").reverse().slice(0, 2).join("/") : "");

// Première occurrence future d'une ligne d'agenda (day 0=lundi…6=dimanche, time "HH:MM"), à partir de `now`.
export const nextOccurrenceOf = (item, now = new Date()) => {
  if (!item || !TIME_RE.test(item.time || "")) return null;
  const [h, m] = item.time.split(":").map(Number);
  const jsDay = (Number(item.day) + 1) % 7;
  for (let add = 0; add < 8; add++) {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + add, h, m, 0, 0);
    if (d.getDay() === jsDay && d.getTime() > now.getTime()) return d;
  }
  return null;
};

export const cancellationFor = (item, date, cancellations) => {
  if (!item || !date) return null;
  const iso = localDateIso(date);
  return (cancellations || []).find((c) => c.time === item.time && Number(c.day) === Number(item.day) && c.date === iso) || null;
};

// Date locale d'une occurrence de remplacement (new_date + new_time), ou null.
export const movedDate = (c) => {
  if (!c || c.kind !== "moved" || !c.new_date || !TIME_RE.test(c.new_time || "")) return null;
  const [y, mo, d] = c.new_date.split("-").map(Number);
  const [h, mi] = c.new_time.split(":").map(Number);
  const dt = new Date(y, mo - 1, d, h, mi, 0, 0);
  return Number.isNaN(dt.getTime()) ? null : dt;
};

// Lot 725 — culte exceptionnel (événement d'église `is_service`) : occurrence unique à `starts_at`.
export const specialDate = (ev) => {
  if (!ev?.is_service || !ev.starts_at) return null;
  const d = new Date(ev.starts_at);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Prochain culte NON annulé parmi toutes les lignes (chaque ligne examinée sur 3 semaines) + occurrences déplacées à venir
// + cultes exceptionnels (`specials` = événements d'église, seuls ceux marqués is_service comptent).
export const nextServiceOccurrence = (schedule, cancellations = [], now = new Date(), specials = []) => {
  let best = null;
  const consider = (date, item) => { if (date && date.getTime() > now.getTime() && (!best || date.getTime() < best.date.getTime())) best = { date, item }; };
  for (const s of Array.isArray(schedule) ? schedule : []) {
    let from = now;
    for (let week = 0; week < 3; week++) {
      const d = nextOccurrenceOf(s, from);
      if (!d) break;
      if (!cancellationFor(s, d, cancellations)) { consider(d, s); break; }
      from = new Date(d.getTime() + 60 * 1000);
    }
  }
  for (const c of cancellations || []) {
    const d = movedDate(c);
    if (d) consider(d, { day: (d.getDay() + 6) % 7, time: c.new_time, title: c.title, moved: true, from_date: c.date, from_time: c.time });
  }
  for (const ev of specials || []) {
    const d = specialDate(ev);
    if (d) consider(d, { day: (d.getDay() + 6) % 7, time: `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`, title: ev.title, special: true, event_id: ev.id });
  }
  return best;
};

export const fmtShortDate = (date, lang) => {
  try { return date.toLocaleDateString(lang || "fr", { weekday: "long", day: "numeric", month: "short" }); } catch { return localDateIso(date); }
};
export const fmtIsoDate = (iso, lang) => {
  try { const [y, m, d] = iso.split("-").map(Number); return fmtShortDate(new Date(y, m - 1, d), lang); } catch { return iso; }
};
